export default __webpack_public_path__ + "static/media/icon_pro_users.00fe5269.svg";